import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import faqRoutes from './faq';

Vue.use( VueRouter );

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue' ),
	},
	{
		path: '/privacy-policy',
		name: 'Privacy Policy',
		component: () => import( /* webpackChunkName: "about" */ '../views/Privacy.vue' ),
	},
	{
		path: '/cookie-policy',
		name: 'Cookie Policy',
		component: () => import( /* webpackChunkName: "about" */ '../views/Cookies.vue' ),
	},
	{
		path: '/terms-of-use',
		name: 'Terms of Use',
		component: () => import( /* webpackChunkName: "about" */ '../views/Terms.vue' ),
	},
	{
		path: '/proposal',
		name: 'Proposal',
		component: () => import( /* webpackChunkName: "about" */ '../views/Proposal.vue' ),
	},
	...faqRoutes,
];

const router = new VueRouter( { routes } );

// A little quality-of-life thing: make sure
// the page scrolls to the top after each
// navigation event. It's annoying if it doesn't!
router.afterEach( () => {
	window.scrollTo( {
		top: 0,
		left: 0,
		behavior: 'smooth',
	} );
} );

export default router;
